// extracted by mini-css-extract-plugin
export default {"section":"about_section__HqGH6","title":"about_title__quZ+x","text":"about_text__Do-Q6"};